import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate, useParams, useLocation } from 'react-router-dom';

const SUPPORTED_LANGUAGES = ['en', 'ka' , 'ru'/*, 'es', 'hy'*/];
const DEFAULT_LANGUAGE = 'en';

export const LanguageRedirectWrapper = () => {
	const { language } = useParams();
	const navigate = useNavigate();
	const { i18n } = useTranslation();
	const location = useLocation();

	useEffect(() => {
		const currentPath = location.pathname;
		const pathParts = currentPath.split('/').filter(part => part !== '');
		
		// If no path parts, redirect to default language + login
		if (pathParts.length === 0) {
			navigate(`/${DEFAULT_LANGUAGE}/login`, { replace: true });
			return;
		}

		const firstPart = pathParts[0];

		// If first part is a supported language
		if (SUPPORTED_LANGUAGES.includes(firstPart)) {
			// Set the language if it's different
			if (language !== firstPart) {
				i18n.changeLanguage(firstPart);
			}
			
			// If there's only a language code without a subsequent path (e.g., "/ka")
			// This commonly happens with OAuth redirects
			if (pathParts.length === 1) {
				navigate(`/${firstPart}/login`, { replace: true });
				return;
			}
			
			// Language is valid and there's a subsequent path, continue normally
			return;
		}

		// If first part is not a supported language, we have an invalid path
		// The user entered something like "/invalid-path" or "/some-route"
		// Instead of trying to guess, redirect to 404 with proper language structure
		navigate(`/${DEFAULT_LANGUAGE}/404`, { replace: true });
		
	}, [language, navigate, i18n, location.pathname]);

	return <Outlet />;
};
